import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ContentBlock } from 'app/shared/components/content-blocks/models/content-blocks.model';

@Component({
  selector: 'kh-content-blocks',
  templateUrl: './content-blocks.component.html',
  styleUrls: ['./content-blocks.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
/**
 * This component is used to display text which may also contain images.
 * Images will be displayed inline with the text.
 */
export class ContentBlocksComponent {
  @Input()
  public blocks?: ContentBlock[] | string;

  @Input()
  public className = '';

  /**
   * Determines if there is valid content to display
   */
  public get hasContent(): boolean {
    if (!this.blocks) {
      return false;
    }

    if (typeof this.blocks === 'string') {
      return this.blocks.trim().length > 0;
    }
    return Array.isArray(this.blocks) && this.blocks.length > 0;
  }

  public isString(value: unknown): boolean {
    return typeof value === 'string';
  }

  public isContentBlockArray(value: unknown): boolean {
    return Array.isArray(value);
  }
}
